var path = '/Users/philipborg/Code/DesignPlacer/src/designPlacer.tpl.html';
var html = "<div> <div id=editors></div> <div id=viewpoint-selectors></div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/designPlacer.tpl.html
// module id = 332
// module chunks = 0